import { BaseModel } from '../email-template/base-model.interface';
import BlockModel from '../email-template/block-model.interface';
import { NotificationInitVariables } from '../template/notifications-model.interface';

export interface YoutubeVideoCtaTextModel extends BaseModel {
  variables?: { [key: string]: string } | YoutubeVideoCtaTextVariables;
}

export interface YoutubeVideoCtaTextVariables {
  YoutubeVideoCtaText: string;
}

export class YoutubeVideoCtaTextInitVariables implements YoutubeVideoCtaTextVariables {
  YoutubeVideoCtaText = '';
}

export class YoutubeVideoCtaTextInitModel implements BlockModel {
  blockId: string = '';
  count: number = 0;
  name: string = '';
  variables: { [key: string]: string };
  notifications: NotificationInitVariables[];

  constructor() {
    const initVars = new YoutubeVideoCtaTextInitVariables();
    this.variables = { ...initVars };
    this.notifications = [new NotificationInitVariables()];
  }
}
